import { render } from "./BusinessMasterDetail.vue?vue&type=template&id=66e0b18e&ts=true"
import script from "./BusinessMasterDetail.vue?vue&type=script&lang=ts"
export * from "./BusinessMasterDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__